
        var result = require("!!../../../../node_modules/css-loader/index.js!./user-avatar.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/user-avatar/user-avatar.component.css
// module id = 1434
// module chunks = 0